import { render, staticRenderFns } from "./Cupom.vue?vue&type=template&id=7aba1600"
import script from "./Cupom.vue?vue&type=script&lang=js"
export * from "./Cupom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports